// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Youtube from '../_raw/ui/icon_youtube.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Youtube);
